import SvgIcon from '@ixigo/icons/SvgIcon';
import cn from '../utils/cn';

export const ETicket = (props: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<SvgIcon
			className={cn(props.className)}
			data-testid="ETicketIcon"
			width="161"
			height="160"
			viewBox="0 0 161 160"
			fill="none"
			{...props}
		>
			<path
				d="M53.8869 77.5056C58.4468 77.5056 62.1359 73.8136 62.1359 69.2557C62.1359 64.6979 58.4468 61.0059 53.8869 61.0059C49.327 61.0059 45.6378 64.6979 45.6378 69.2557C45.6378 73.8136 49.327 77.5056 53.8869 77.5056Z"
				fill="#FC790D"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M106.42 47V113H124.5C130.575 113 135.5 108.075 135.5 102V96.5801C135.471 96.5579 135.436 96.5336 135.396 96.5082C135.276 96.4326 135.134 96.3643 134.983 96.3138C128.236 94.0588 123.292 87.7435 123.292 80.2078C123.292 72.672 128.236 66.3567 134.983 64.1018C135.134 64.0512 135.276 63.9829 135.396 63.9073C135.436 63.8819 135.471 63.8577 135.5 63.8354V58C135.5 51.9249 130.575 47 124.5 47L106.42 47ZM101.42 47V113H36.5C30.4249 113 25.5 108.075 25.5 102V96.5801C25.5293 96.5579 25.5638 96.5336 25.604 96.5082C25.7238 96.4326 25.8662 96.3643 26.0174 96.3138C32.7638 94.0588 37.7081 87.7436 37.7081 80.2078C37.7081 72.672 32.7638 66.3567 26.0174 64.1018C25.8662 64.0512 25.7238 63.9829 25.604 63.9073C25.5638 63.8819 25.5293 63.8577 25.5 63.8354L25.5 58C25.5 51.9249 30.4249 47 36.5 47L101.42 47ZM36.5 42C27.6634 42 20.5 49.1634 20.5 58L20.5 64.2078C20.5 66.4169 22.3372 68.1436 24.4324 68.8439C29.2454 70.4526 32.7081 74.9327 32.7081 80.2078C32.7081 85.4828 29.2454 89.9629 24.4324 91.5716C22.3372 92.2719 20.5 93.9986 20.5 96.2078V102C20.5 110.837 27.6634 118 36.5 118H124.5C133.337 118 140.5 110.837 140.5 102V96.2078C140.5 93.9986 138.663 92.2719 136.568 91.5716C131.755 89.9629 128.292 85.4828 128.292 80.2078C128.292 74.9327 131.755 70.4526 136.568 68.8439C138.663 68.1436 140.5 66.4169 140.5 64.2078V58C140.5 49.1634 133.337 42 124.5 42L36.5 42Z"
				fill="#0770E4"
			/>
		</SvgIcon>
	);
};

export default ETicket;
